import { MINUTE } from 'Utils/time';
import _ from 'lodash';

export default {
  name: 'appComponent',
  template:
      `
      <topnav></topnav>
      <rv-side-nav></rv-side-nav>
      <div ui-view class="viewport" id="main-content" class="no-padding">
      </div>
      `,
  controller: AppController,
  controllerAs: 'AppCtrl'
};

/* @ngInject */
function AppController(
  $rootScope,
  $state,
  $sails,
  hotkeys,
  appConfig,
  growl,
  DashboardInfoService,
  DashboardService,
  EquipmentInfoService,
  ModalService,
  QuickFindService,
  SessionService,
  UserInfoService,
  GroupService
) {
  const vm = this;

  hotkeys.bindTo($rootScope).add({
    combo: 'mod+k',
    callback: ModalService.quickfind
  });


  vm.user = appConfig.user;
  vm.isOpen = true;
  vm.sidebarWidth = 250;
  vm.isDragged = false;

  vm.setSidebarWidth = (newWidth) => {
    vm.sidebarWidth = newWidth;
    vm.isDragged = true;
  };

  // Injected in this component to pre-fetch items rather than all-at-once when the modal is first opened
  _.noop(QuickFindService);

  DashboardInfoService.getAllDashboards();
  GroupService.subscribeToGroupBroadcasts();
  UserInfoService.updateConnectionLog();

  /*
     *
     * @name Sails Socket Event listener/re-broadcaster
     *
     * Function to handle the sails socket events, and signal an angular
     * broadcast from this top-level controller. This way the other parts of the app
     * only have to listen for a particular subset of events (rather than listening
     * to every event and then deciding if the event matters to it or not).
     *
     * @param {Object} event [the Event object sent from the sails socket]
     */
  const onEventCreated = (event) => {
    event.equipment = EquipmentInfoService.getEquipment(event.equipment);
    if (event.equipment?.id) {
      $rootScope.$broadcast(`event:${event.equipment.id}`, event);
      $rootScope.$broadcast(`event:${event.eventName}`, event);
    }
  };

  const onEventUpdated = (event) => {
    EquipmentInfoService.getEquipmentById(event.equipment)
      .then((equipment) => {
        event.equipment = equipment;
        $rootScope.$broadcast('event:updated', event);
      });
  };

  const onEventDeleted = (eventId) => {
    $rootScope.$broadcast('event:deleted', eventId);
  };

  const onReportCreated = (reportArray) => {
    $rootScope.$broadcast(`report:${reportArray[0].equipment}`, reportArray);
  };

  const onReportUpdated = (reportObj) => {
    $rootScope.$broadcast('report:updated', reportObj);
  };

  const onDashboardCreate = (createdDashboard) => {
    $rootScope.$broadcast('dashboard:created', createdDashboard);
  };

  const onDashboardDestroyed = (destroyedDashboard) => {
    $rootScope.$broadcast('dashboard:destroyed', destroyedDashboard[0]);
  };

  $sails.on('Event:deleted', onEventDeleted);
  $sails.on('Event:created', onEventCreated);
  $sails.on('Event:updated', onEventUpdated);
  $sails.on('Report:created', onReportCreated);
  $sails.on('Report:updated', onReportUpdated);
  $sails.on('Dashboard:created', onDashboardCreate);
  $sails.on('Dashboard:destroyed', onDashboardDestroyed);

  /**
   * end of Sails Socket Event listener/re-broadcaster
   */

  // Resubscribe on reconnect
  $sails.on('reconnect', () => {
    UserInfoService.updateConnectionLog();
    EquipmentInfoService.getEquipmentFromServer();
    if ($state.current.name === 'dashboard') {
      const equipment = DashboardInfoService.getEquipment(DashboardService.getCurrentDashboard());
      if (equipment.length) {
        EquipmentInfoService.subscribeToGivenEquipment(equipment);
      }
    }
    GroupService.subscribeToGroupBroadcasts();
  });

  /*
    ** //////////////
    ** Session Expiry
    ** //////////////
    */
  const callAfterCountdown = (handler, durationInMilli) => ({
    duration: durationInMilli,
    remaining: durationInMilli,
    active: false,
    start() {
      if (this.active) {
        return;
      }
      this.active = true;
      this.ticker = setInterval(() => {
        this.remaining -= MINUTE;
        if (this.remaining <= 0) {
          this.stop();
          handler();
        }
      }, MINUTE);
    },
    stop() {
      if (this.ticker) {
        clearInterval(this.ticker);
      }
      this.active = false;
    },
    reset(newDuration) {
      if (_.isFinite(newDuration)) {
        this.duration = newDuration;
      }
      this.remaining = this.duration;
    },
    restart(newDuration) {
      this.stop();
      this.reset(newDuration);
      this.start();
    }
  });

  const terminateTimer = callAfterCountdown(SessionService.renew, MINUTE);

  let warningMsg;
  const wereNotJokingWellDoItMan = () => {
    warningMsg = growl.warning('Are you still there? Session will close due to inactivity…', { ttl: MINUTE });
    terminateTimer.start();
  };

  const getMinutesBeforeWarn = () => appConfig.sessionMaxAge - MINUTE;
  const warningTimer = callAfterCountdown(wereNotJokingWellDoItMan, getMinutesBeforeWarn());

  warningTimer.start();

  const deescalate = () => {

    if (!this.renew) {
      this.renew = Date.now();
    }

    const timeSinceLastSessionRenew = Date.now() - this.renew;

    if (timeSinceLastSessionRenew >= MINUTE) {
      this.renew = Date.now();

      SessionService.renew()
        .then(() => warningTimer.restart(getMinutesBeforeWarn()));
    }

    if (terminateTimer.active) {
      terminateTimer.stop();
      terminateTimer.reset();
      if (warningMsg && warningMsg.destroy) {
        warningMsg.destroy();
        warningMsg = undefined;
      }
    }
  };
  _.forEach(
    ['touchstart', 'touchmove', 'mousemove', 'keydown', 'click'],
    event => document.body.addEventListener(event, _.throttle(deescalate, 1000), { passive: true }));
}
